import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from '@apollo/client';
import { InfoIcon } from '@chakra-ui/icons';
import { Flex } from '@chakra-ui/layout';
import { Button, ButtonGroup, Divider, FormControl, FormErrorMessage, HStack, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Radio, RadioGroup, Stack, Text, Textarea, Tooltip, VStack, useToast } from '@chakra-ui/react';
import AddressFormatter from '@shopify/address';
import moment from 'moment';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/dist/client/router';
import * as R from 'ramda';
import { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import TextareaAutosize from 'react-textarea-autosize';
import { Gender } from 'src/types';
import ClientIdentityByMobileAndAppId from '../../src/graphql/ClientIdentityByMobileAndAppId.gql';
import httpClient from '../api/httpClient';
import { BranchConstants, GENDER_TYPE } from '../constants';
import dataTestID from '../constants/DataTestIndex';
import { cities as cityList } from '../constants/cities';
import { BirthdayPopup } from './common/BirthdayPopup';
import { Select } from './common/Form/Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var chakraReactSelectStyles = {
  container: function container(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      w: '50%'
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: 'gray.400'
    });
  },
  control: function control(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      background: 'white'
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      p: [0, 1]
    });
  }
};
export var EditOrgClientProfileModal = function EditOrgClientProfileModal(_ref) {
  var _cityList$country, _cityList$country2, _cityList$country3, _cityList$country$cit, _cityList$country4, _cityList$country4$ci, _result$client_identi, _result$client_identi2;

  var isOpen = _ref.isOpen,
      name = _ref.name,
      mobile = _ref.mobile,
      onClose = _ref.onClose,
      real_name = _ref.real_name,
      clientId = _ref.clientId,
      profileId = _ref.profileId,
      refetchAll = _ref.refetchAll,
      identity_number = _ref.identity_number,
      special_note = _ref.special_note,
      allergy_note = _ref.allergy_note,
      gender = _ref.gender,
      birthday = _ref.birthday,
      city = _ref.city,
      country = _ref.country,
      street = _ref.street,
      header = _ref.header,
      record_number = _ref.record_number;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState([]),
      countries = _useState2[0],
      setCountries = _useState2[1];

  var _useState3 = useState([]),
      cities = _useState3[0],
      setCities = _useState3[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useRouter = useRouter(),
      locale = _useRouter.locale;

  var _useForm = useForm({
    mode: 'all',
    defaultValues: {
      birthday: birthday,
      gender: gender,
      identity_number: identity_number,
      mobile: mobile,
      special_note: special_note,
      allergy_note: allergy_note,
      country: country ? {
        value: country !== null && country !== void 0 ? country : ''
      } : null,
      city: country ? {
        label: (_cityList$country = cityList[country]) !== null && _cityList$country !== void 0 && _cityList$country[city] ? t((_cityList$country2 = cityList[country]) === null || _cityList$country2 === void 0 ? void 0 : _cityList$country2[city].i18n, (_cityList$country3 = cityList[country]) === null || _cityList$country3 === void 0 ? void 0 : _cityList$country3[city].label) : '',
        value: (_cityList$country$cit = (_cityList$country4 = cityList[country]) === null || _cityList$country4 === void 0 ? void 0 : (_cityList$country4$ci = _cityList$country4[city]) === null || _cityList$country4$ci === void 0 ? void 0 : _cityList$country4$ci.value) !== null && _cityList$country$cit !== void 0 ? _cityList$country$cit : ''
      } : null,
      street: street !== null && street !== void 0 ? street : '',
      real_name: real_name || name
    }
  }),
      control = _useForm.control,
      setValue = _useForm.setValue,
      handleSubmit = _useForm.handleSubmit,
      isDirty = _useForm.formState.isDirty,
      reset = _useForm.reset;

  var _useQuery = useQuery(ClientIdentityByMobileAndAppId, {
    variables: {
      mobile: mobile
    },
    skip: !mobile
  }),
      result = _useQuery.data,
      loading1 = _useQuery.loading;

  var toast = useToast();
  var userData = result === null || result === void 0 ? void 0 : (_result$client_identi = result.client_identities) === null || _result$client_identi === void 0 ? void 0 : (_result$client_identi2 = _result$client_identi[0]) === null || _result$client_identi2 === void 0 ? void 0 : _result$client_identi2.client;
  var modalRef = useRef();
  useEffect(function () {
    // set default value
    if (userData) {
      if (!(real_name || name)) {
        setValue('real_name', userData.name);
      }

      if (!identity_number) {
        setValue('identity_number', userData.identity_number);
      }
    }
  }, [userData, real_name, name, identity_number, setValue]);
  useEffect(function () {
    if (!locale) {
      return;
    }

    var addressFormatter = new AddressFormatter(locale);
    addressFormatter.getCountries().then(function (countries) {
      // sort Taiwan to top
      var sorted = countries.sort(function (_ref2, _ref3) {
        var a = _ref2.code;
        var b = _ref3.code;
        return a === 'TW' ? -1 : b === 'TW' ? 1 : 0;
      });
      var options = [{
        label: t('common:form.pleaseEnterOrSelect', '請輸入或選擇'),
        value: ''
      }].concat(sorted.map(function (item) {
        return {
          label: item.name,
          value: item.code
        };
      }));
      setCountries(options);
    });

    if (country) {
      setCities(R.pipe(R.values, R.map(function (item) {
        return {
          label: t(item.i18n, item.label),
          value: item.value
        };
      }), R.concat([{
        label: t('common:form.pleaseEnterOrSelect', '請輸入或選擇'),
        value: ''
      }]))(cityList[country]));
      addressFormatter.getCountry(country).then(function (value) {
        setValue('country', {
          label: value.name,
          value: country
        });
      })["catch"](function (error) {
        console.log(error);
      });
    }
  }, [locale, setValue, country, t]);

  var saveData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var _data$city$value, _data$city, _data$country$value, _data$country, _data$street, payload;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              payload = {
                identity_number: data.identity_number,
                gender: data.gender || undefined,
                real_name: data.real_name,
                allergy_note: data.allergy_note,
                special_note: data.special_note,
                address_attributes: {
                  city: (_data$city$value = (_data$city = data.city) === null || _data$city === void 0 ? void 0 : _data$city.value) !== null && _data$city$value !== void 0 ? _data$city$value : '',
                  country: (_data$country$value = (_data$country = data.country) === null || _data$country === void 0 ? void 0 : _data$country.value) !== null && _data$country$value !== void 0 ? _data$country$value : '',
                  street: (_data$street = data.street) !== null && _data$street !== void 0 ? _data$street : ''
                },
                birthday: data.birthday
              };

              if (!profileId) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return httpClient.put("/orgs/".concat(BranchConstants.ORG_ID, "/client_profiles/").concat(profileId), payload);

            case 6:
              _context.next = 10;
              break;

            case 8:
              _context.next = 10;
              return httpClient.post("/orgs/".concat(BranchConstants.ORG_ID, "/client_profiles"), _objectSpread(_objectSpread({}, payload), {}, {
                client_id: clientId,
                mobile: mobile,
                branch_id: BranchConstants.BRANCH_ID
              }));

            case 10:
              toast({
                title: profileId ? t('info_mgmt:normal.updateSuccessfully', '更新成功') : t('common:normal.bindSuccess', '綁定成功'),
                description: profileId ? '' : t('common:normal.bindDone', '綁定設定完成'),
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top'
              });
              _context.next = 13;
              return refetchAll();

            case 13:
              onClose();
              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);
              toast({
                title: t('common:saveFailed', '儲存失敗'),
                status: 'error',
                duration: 1000,
                isClosable: true,
                position: 'top'
              });

            case 20:
              _context.prev = 20;
              setLoading(false);
              return _context.finish(20);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16, 20, 23]]);
    }));

    return function saveData(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose() {
    // Prevents the modal from closing while data is being saved
    if (!loading) {
      reset();
      onClose();
    }
  };

  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onClose: handleClose,
    size: "2xl",
    isCentered: true,
    e2eid: "components_EditOrgClientProfileModal_Modal",
    children: [/*#__PURE__*/_jsx(ModalOverlay, {
      e2eid: "components_EditOrgClientProfileModal_ModalOverlay"
    }), /*#__PURE__*/_jsxs(ModalContent, {
      p: "3",
      e2eid: "components_EditOrgClientProfileModal_ModalContent",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        e2eid: "components_EditOrgClientProfileModal_ModalHeader",
        children: header
      }), /*#__PURE__*/_jsx(ModalCloseButton, {
        e2eid: "components_EditOrgClientProfileModal_ModalCloseButton"
      }), /*#__PURE__*/_jsx(ModalBody, {
        maxH: "70vh",
        overflow: "auto",
        ref: modalRef,
        e2eid: "components_EditOrgClientProfileModal_ModalBody",
        children: loading1 ? /*#__PURE__*/_jsx(Flex, {
          w: "100%",
          height: "522px",
          alignItems: "center",
          justify: "center",
          e2eid: "components_EditOrgClientProfileModal_Flex",
          children: /*#__PURE__*/_jsx("img", {
            src: "/loading.gif",
            width: "15%",
            e2eid: "components_EditOrgClientProfileModal_img"
          })
        }) : /*#__PURE__*/_jsxs(VStack, {
          w: "full",
          color: "blackAlpha.300",
          spacing: "4",
          e2eid: "components_EditOrgClientProfileModal_VStack",
          children: [/*#__PURE__*/_jsxs(VStack, {
            w: "full",
            spacing: 2,
            color: "blackAlpha.300",
            e2eid: "components_EditOrgClientProfileModal_VStack_9",
            children: [/*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "flex-start",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsxs(HStack, {
                w: "138px",
                mt: 2,
                spacing: 1,
                e2eid: "components_EditOrgClientProfileModal_HStack_11",
                children: [/*#__PURE__*/_jsx(Text, {
                  e2eid: "components_EditOrgClientProfileModal_Text",
                  children: t('common:normal.medical_record_name', '病歷名稱')
                }), /*#__PURE__*/_jsx(Text, {
                  color: "red",
                  e2eid: "components_EditOrgClientProfileModal_Text_13",
                  children: "*"
                })]
              }), /*#__PURE__*/_jsx(Controller, {
                name: "real_name",
                rules: {
                  required: true
                },
                control: control,
                render: function render(_ref5) {
                  var field = _ref5.field,
                      invalid = _ref5.fieldState.invalid;
                  return /*#__PURE__*/_jsxs(FormControl, {
                    flex: "1",
                    isInvalid: invalid,
                    e2eid: "components_EditOrgClientProfileModal_FormControl",
                    children: [/*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
                      flex: "1",
                      h: 10
                    }, field), {}, {
                      "data-test": dataTestID.editOrgClientProfileModal.real_name,
                      e2eid: "components_EditOrgClientProfileModal_Input"
                    })), invalid && /*#__PURE__*/_jsx(FormErrorMessage, {
                      e2eid: "components_EditOrgClientProfileModal_FormErrorMessage",
                      children: t('common:form.requireAndCannotBeEmpty', '必填欄位不得空白')
                    })]
                  });
                },
                e2eid: "components_EditOrgClientProfileModal_Controller"
              })]
            }), /*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "center",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsxs(HStack, {
                w: "138px",
                e2eid: "components_EditOrgClientProfileModal_HStack_19",
                children: [/*#__PURE__*/_jsx(Text, {
                  e2eid: "components_EditOrgClientProfileModal_Text",
                  children: t('client:normal.record_number', '病歷號')
                }), /*#__PURE__*/_jsx(Tooltip, {
                  wordBreak: "keep-all",
                  placement: "auto-end",
                  shouldWrapChildren: true,
                  label: t('client:normal.record_number_descriptions', "\u7CFB\u7D71\u4EE5\u5BA2\u6236\u7684\u6C11\u570B\u751F\u65E5\u4F5C\u70BA\u53D6\u865F\u57FA\u790E\uFF0C\u7D44\u6210\u75C5\u6B77\u865F ".concat(BranchConstants.RECORD_NUMBER_PREFIX_FORMAT, "  + \u5169\u78BC\u9806\u5E8F\u6D41\u6C34\u865F"), {
                    format: BranchConstants.RECORD_NUMBER_PREFIX_FORMAT
                  }),
                  fontSize: "md",
                  e2eid: "components_EditOrgClientProfileModal_Tooltip",
                  children: /*#__PURE__*/_jsx(InfoIcon, {
                    w: 4,
                    h: 4,
                    my: 1,
                    e2eid: "components_EditOrgClientProfileModal_InfoIcon"
                  })
                })]
              }), /*#__PURE__*/_jsx(Input, {
                flex: "1",
                h: 10,
                readOnly: true,
                name: "record_number",
                disabled: true,
                value: record_number,
                "data-test": dataTestID.editOrgClientProfileModal.record_number,
                e2eid: "components_EditOrgClientProfileModal_Input"
              })]
            }), /*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "center",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsx(Text, {
                w: "138px",
                e2eid: "components_EditOrgClientProfileModal_Text",
                children: t('common:normal.biological_sex', '生理性別')
              }), /*#__PURE__*/_jsx(Controller, {
                name: "gender",
                control: control,
                render: function render(_ref6) {
                  var field = _ref6.field,
                      invalid = _ref6.fieldState.invalid;
                  return /*#__PURE__*/_jsx(FormControl, {
                    flex: "1",
                    isInvalid: invalid,
                    e2eid: "components_EditOrgClientProfileModal_FormControl",
                    children: /*#__PURE__*/_jsx(RadioGroup, {
                      onChange: field.onChange,
                      value: field.value,
                      e2eid: "components_EditOrgClientProfileModal_RadioGroup",
                      children: /*#__PURE__*/_jsxs(Stack, {
                        direction: "row",
                        "data-test": dataTestID.editOrgClientProfileModal.gender,
                        e2eid: "components_EditOrgClientProfileModal_Stack",
                        children: [/*#__PURE__*/_jsx(Radio, {
                          value: Gender.female,
                          e2eid: "components_EditOrgClientProfileModal_Radio",
                          children: t(GENDER_TYPE.female.i18n, '女性')
                        }), /*#__PURE__*/_jsx(Radio, {
                          value: Gender.male,
                          e2eid: "components_EditOrgClientProfileModal_Radio_31",
                          children: t(GENDER_TYPE.male.i18n, '男性')
                        })]
                      })
                    })
                  });
                },
                e2eid: "components_EditOrgClientProfileModal_Controller"
              })]
            }), /*#__PURE__*/_jsx(Controller, {
              name: "birthday",
              control: control,
              rules: {
                required: t('common:form.requireAndCannotBeEmpty', '必填欄位不得空白'),
                validate: {
                  date: function date(value) {
                    if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
                      return t('common:form.wrongDateFormat', '日期格式不正確，請輸入 YYYY-MM-DD 的格式');
                    }

                    if (!moment().isAfter(value)) {
                      return t('common:form.futureBirthdayNotAllowed', '生日不能超過今天');
                    }

                    return true;
                  }
                }
              },
              render: function render(_ref7) {
                var field = _ref7.field,
                    _ref7$fieldState = _ref7.fieldState,
                    invalid = _ref7$fieldState.invalid,
                    error = _ref7$fieldState.error,
                    isValidating = _ref7$fieldState.isValidating;
                return /*#__PURE__*/_jsx(FormControl, {
                  isInvalid: invalid,
                  e2eid: "components_EditOrgClientProfileModal_FormControl",
                  children: /*#__PURE__*/_jsxs(HStack, {
                    w: "full",
                    alignItems: "flex-start",
                    e2eid: "components_EditOrgClientProfileModal_HStack",
                    children: [/*#__PURE__*/_jsxs(HStack, {
                      w: "138px",
                      mt: 2,
                      spacing: 1,
                      e2eid: "components_EditOrgClientProfileModal_HStack_35",
                      children: [/*#__PURE__*/_jsx(Text, {
                        e2eid: "components_EditOrgClientProfileModal_Text",
                        children: t('common:normal.birthday', '生日')
                      }), /*#__PURE__*/_jsx(Text, {
                        color: "red",
                        e2eid: "components_EditOrgClientProfileModal_Text_37",
                        children: "*"
                      })]
                    }), /*#__PURE__*/_jsxs(VStack, {
                      flex: "1",
                      alignItems: "flex-start",
                      spacing: "0",
                      e2eid: "components_EditOrgClientProfileModal_VStack",
                      children: [/*#__PURE__*/_jsxs(InputGroup, {
                        flex: "1",
                        zIndex: "popover",
                        e2eid: "components_EditOrgClientProfileModal_InputGroup",
                        children: [/*#__PURE__*/_jsx(Input, {
                          flex: "1",
                          h: 10,
                          value: field.value,
                          variant: "outline",
                          "data-test": dataTestID.editOrgClientProfileModal.birthday,
                          onChange: field.onChange,
                          e2eid: "components_EditOrgClientProfileModal_Input"
                        }), /*#__PURE__*/_jsx(InputRightElement, {
                          e2eid: "components_EditOrgClientProfileModal_InputRightElement",
                          children: /*#__PURE__*/_jsx(BirthdayPopup, {
                            date: moment(field.value),
                            setDate: function setDate(data) {
                              field.onChange(moment(data).format('YYYY-MM-DD'));
                            },
                            e2eid: "components_EditOrgClientProfileModal_BirthdayPopup"
                          })
                        })]
                      }), /*#__PURE__*/_jsx(FormErrorMessage, {
                        color: "red.400",
                        e2eid: "components_EditOrgClientProfileModal_FormErrorMessage",
                        children: error === null || error === void 0 ? void 0 : error.message
                      }), !BranchConstants.IS_CHINA_SITE && !invalid && /*#__PURE__*/_jsx(Text, {
                        color: "gray.400",
                        fontSize: "sm",
                        e2eid: "components_EditOrgClientProfileModal_Text",
                        children: "".concat(t('common:button.rocYear', '民國'), " ").concat(moment(field.value).year() - 1911).concat(moment(field.value).format(' 年 MM 月 DD 日'))
                      }), !isValidating && !invalid && /*#__PURE__*/_jsx(Text, {
                        color: "red.400",
                        fontSize: "sm",
                        e2eid: "components_EditOrgClientProfileModal_Text_45",
                        children: t('client:normal.renewRecordNumber', '提醒：更改客戶生日後，病歷號將會自動更新')
                      })]
                    })]
                  })
                });
              },
              e2eid: "components_EditOrgClientProfileModal_Controller"
            })]
          }), /*#__PURE__*/_jsx(Divider, {
            my: "2",
            e2eid: "components_EditOrgClientProfileModal_Divider"
          }), /*#__PURE__*/_jsxs(VStack, {
            w: "full",
            my: 2,
            spacing: 2,
            e2eid: "components_EditOrgClientProfileModal_VStack",
            children: [/*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "flex-start",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsx(Text, {
                w: "138px",
                mt: 2,
                e2eid: "components_EditOrgClientProfileModal_Text",
                children: t('common:normal.identityNumber', '身分證字號')
              }), /*#__PURE__*/_jsx(Controller, {
                name: "identity_number",
                control: control,
                rules: {
                  validate: {
                    message: function message(value) {
                      if (BranchConstants.IS_CHINA_SITE || !value) {
                        return;
                      }

                      if (value.length <= BranchConstants.MAX_IDENTITY_LENGTH) {
                        return;
                      }

                      return t('client:invalid_identity', "\u8EAB\u5206\u8B49\u5B57\u865F\u81F3\u591A\u70BA ".concat(BranchConstants.MAX_IDENTITY_LENGTH, " \u78BC"), {
                        count: BranchConstants.MAX_IDENTITY_LENGTH
                      });
                    }
                  }
                },
                render: function render(_ref8) {
                  var field = _ref8.field,
                      _ref8$fieldState = _ref8.fieldState,
                      invalid = _ref8$fieldState.invalid,
                      error = _ref8$fieldState.error;
                  return /*#__PURE__*/_jsxs(FormControl, {
                    flex: "1",
                    isInvalid: invalid,
                    e2eid: "components_EditOrgClientProfileModal_FormControl",
                    children: [/*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
                      flex: "1",
                      h: 10
                    }, field), {}, {
                      "data-test": dataTestID.editOrgClientProfileModal.identity_number,
                      e2eid: "components_EditOrgClientProfileModal_Input"
                    })), error && /*#__PURE__*/_jsx(FormErrorMessage, {
                      e2eid: "components_EditOrgClientProfileModal_FormErrorMessage",
                      children: error && (error === null || error === void 0 ? void 0 : error.message)
                    })]
                  });
                },
                e2eid: "components_EditOrgClientProfileModal_Controller"
              })]
            }), /*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "center",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsxs(HStack, {
                w: "138px",
                e2eid: "components_EditOrgClientProfileModal_HStack_55",
                children: [/*#__PURE__*/_jsx(Text, {
                  e2eid: "components_EditOrgClientProfileModal_Text",
                  children: t('client:normal.boundMobile', '綁定電話')
                }), /*#__PURE__*/_jsx(Tooltip, {
                  wordBreak: "keep-all",
                  placement: "auto-end",
                  shouldWrapChildren: true,
                  label: t('client:normal.change_mobile_remind', "\u9810\u8A2D\u7D81\u5B9A ".concat(BranchConstants.BOOKING_SOURCE_TYPE, " \u7684\u9810\u7D04\u96FB\u8A71\u3002\u91CF\u6E2C\u8F38\u5165\u96FB\u8A71\u6642\uFF0C\u8ACB\u52D9\u5FC5\u78BA\u4FDD\u8207\u7D81\u5B9A\u7684\u96FB\u8A71\u76F8\u540C\u3002"), {
                    source: BranchConstants.BOOKING_SOURCE_TYPE
                  }),
                  fontSize: "md",
                  e2eid: "components_EditOrgClientProfileModal_Tooltip",
                  children: /*#__PURE__*/_jsx(InfoIcon, {
                    w: 4,
                    h: 4,
                    my: 1,
                    e2eid: "components_EditOrgClientProfileModal_InfoIcon"
                  })
                })]
              }), /*#__PURE__*/_jsx(Input, {
                flex: "1",
                h: 10,
                readOnly: true,
                name: "mobile",
                disabled: true,
                value: mobile,
                "data-test": dataTestID.editOrgClientProfileModal.mobile,
                e2eid: "components_EditOrgClientProfileModal_Input"
              })]
            }), /*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "center",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsx(HStack, {
                w: "138px",
                e2eid: "components_EditOrgClientProfileModal_HStack_61",
                children: /*#__PURE__*/_jsx(Text, {
                  e2eid: "components_EditOrgClientProfileModal_Text",
                  children: t('common:normal.contact_address', '聯絡地址')
                })
              }), /*#__PURE__*/_jsxs(HStack, {
                flex: "1",
                spacing: 2,
                e2eid: "components_EditOrgClientProfileModal_HStack",
                children: [/*#__PURE__*/_jsx(Controller, {
                  name: "country",
                  control: control,
                  render: function render(_ref9) {
                    var field = _ref9.field;
                    return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, field), {}, {
                      withPortal: Boolean(modalRef.current),
                      menuPortalTarget: modalRef.current,
                      customStyles: chakraReactSelectStyles,
                      noOptionsMessage: function noOptionsMessage() {
                        return t('common:form.noOptions', '無選項');
                      },
                      selectOption: field.value,
                      onChange: function onChange(value) {
                        field.onChange(value);
                        var cities = cityList === null || cityList === void 0 ? void 0 : cityList[value.value];

                        if (cities) {
                          setCities(R.pipe(R.values, R.map(function (item) {
                            return {
                              label: t(item.i18n, item.label),
                              value: item.value
                            };
                          }), R.concat([{
                            label: t('common:form.pleaseEnterOrSelect', '請輸入或選擇'),
                            value: ''
                          }]))(cities));
                        } else {
                          setCities([]);
                          setValue('city', null);
                        }
                      },
                      placeholder: t('common:form.pleaseEnterOrSelect', '請輸入或選擇'),
                      options: countries,
                      e2eid: "components_EditOrgClientProfileModal_Select"
                    }));
                  },
                  e2eid: "components_EditOrgClientProfileModal_Controller"
                }), /*#__PURE__*/_jsx(Controller, {
                  name: "city",
                  control: control,
                  render: function render(_ref10) {
                    var field = _ref10.field;
                    return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, field), {}, {
                      withPortal: Boolean(modalRef.current),
                      menuPortalTarget: modalRef.current,
                      isDisabled: !cities.length,
                      customStyles: chakraReactSelectStyles,
                      noOptionsMessage: function noOptionsMessage() {
                        return t('common:form.noOptions', '無選項');
                      },
                      placeholder: t('common:form.pleaseEnterOrSelect', '請輸入或選擇'),
                      options: cities || [],
                      e2eid: "components_EditOrgClientProfileModal_Select"
                    }));
                  },
                  e2eid: "components_EditOrgClientProfileModal_Controller"
                })]
              })]
            }), /*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "center",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsx(HStack, {
                w: "138px",
                e2eid: "components_EditOrgClientProfileModal_HStack_69"
              }), /*#__PURE__*/_jsx(HStack, {
                flex: "1",
                e2eid: "components_EditOrgClientProfileModal_HStack_70",
                children: /*#__PURE__*/_jsx(Controller, {
                  name: "street",
                  control: control,
                  render: function render(_ref11) {
                    var field = _ref11.field;
                    return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
                      w: "full",
                      h: 10
                    }, field), {}, {
                      variant: "outline",
                      "data-test": dataTestID.editOrgClientProfileModal.birthday,
                      e2eid: "components_EditOrgClientProfileModal_Input"
                    }));
                  },
                  e2eid: "components_EditOrgClientProfileModal_Controller"
                })
              })]
            }), /*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "flex-start",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsx(Text, {
                w: "138px",
                mt: 2,
                e2eid: "components_EditOrgClientProfileModal_Text",
                children: t('client:normal.drugAllergy', '藥物過敏')
              }), /*#__PURE__*/_jsx(Controller, {
                name: "allergy_note",
                control: control,
                render: function render(_ref12) {
                  var field = _ref12.field,
                      _ref12$fieldState = _ref12.fieldState,
                      invalid = _ref12$fieldState.invalid,
                      error = _ref12$fieldState.error;
                  return /*#__PURE__*/_jsxs(FormControl, {
                    flex: "1",
                    isInvalid: invalid,
                    e2eid: "components_EditOrgClientProfileModal_FormControl",
                    children: [/*#__PURE__*/_jsx(Textarea, _objectSpread(_objectSpread({
                      as: TextareaAutosize,
                      noOfLines: 3,
                      flex: "1"
                    }, field), {}, {
                      e2eid: "components_EditOrgClientProfileModal_Textarea"
                    })), error && /*#__PURE__*/_jsx(FormErrorMessage, {
                      e2eid: "components_EditOrgClientProfileModal_FormErrorMessage",
                      children: error && (error === null || error === void 0 ? void 0 : error.message)
                    })]
                  });
                },
                e2eid: "components_EditOrgClientProfileModal_Controller"
              })]
            }), /*#__PURE__*/_jsxs(HStack, {
              w: "full",
              alignItems: "flex-start",
              e2eid: "components_EditOrgClientProfileModal_HStack",
              children: [/*#__PURE__*/_jsx(Text, {
                w: "138px",
                mt: 2,
                e2eid: "components_EditOrgClientProfileModal_Text",
                children: t('client:normal.specialRemarks', '特殊備註')
              }), /*#__PURE__*/_jsx(Controller, {
                name: "special_note",
                control: control,
                render: function render(_ref13) {
                  var field = _ref13.field,
                      _ref13$fieldState = _ref13.fieldState,
                      invalid = _ref13$fieldState.invalid,
                      error = _ref13$fieldState.error;
                  return /*#__PURE__*/_jsxs(FormControl, {
                    flex: "1",
                    isInvalid: invalid,
                    e2eid: "components_EditOrgClientProfileModal_FormControl",
                    children: [/*#__PURE__*/_jsx(Textarea, _objectSpread(_objectSpread({
                      as: TextareaAutosize,
                      noOfLines: 3,
                      flex: "1"
                    }, field), {}, {
                      e2eid: "components_EditOrgClientProfileModal_Textarea"
                    })), error && /*#__PURE__*/_jsx(FormErrorMessage, {
                      e2eid: "components_EditOrgClientProfileModal_FormErrorMessage",
                      children: error && (error === null || error === void 0 ? void 0 : error.message)
                    })]
                  });
                },
                e2eid: "components_EditOrgClientProfileModal_Controller"
              })]
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(ModalFooter, {
        e2eid: "components_EditOrgClientProfileModal_ModalFooter",
        children: /*#__PURE__*/_jsxs(ButtonGroup, {
          alignItems: "center",
          justifyContent: "flex-end",
          w: "full",
          e2eid: "components_EditOrgClientProfileModal_ButtonGroup",
          children: [/*#__PURE__*/_jsx(Button, {
            px: "10",
            mr: 2,
            variant: "outline",
            onClick: handleClose,
            e2eid: "components_EditOrgClientProfileModal_Button",
            children: record_number ? t('common:button.cancelEdit', '取消編輯') : t('common:button.cancel', '取消')
          }), /*#__PURE__*/_jsx(Button, {
            px: "10",
            isDisabled: !isDirty,
            isLoading: loading,
            onClick: handleSubmit(saveData),
            e2eid: "components_EditOrgClientProfileModal_Button_88",
            children: record_number ? t('common:button.saveUpdate', '儲存更新') : t('common:normal.createPatientID', '建立病歷號')
          })]
        })
      })]
    })]
  });
};